import { memo, lazy, Suspense } from 'react';
import { AdminRouter } from './AdminRouter';
import { DefaultRouter } from './DefaultRouter';
import { useUserRoles } from '@/hooks/useUserRoles';
import { LoadingSpinner } from '@/components/common/LoadingSpinner';

const KnowledgeSection = lazy(() => import('@/components/knowledge/KnowledgeSection'));

type RouteType = 'admin' | 'knowledge' | 'default';

interface ContentRouterProps {
  routeType: RouteType;
  currentRole: string;
}

export const ContentRouter = memo<ContentRouterProps>(({ routeType, currentRole }) => {
  // Get user roles to check if user is admin
  const { roles: userRoles, isSuperAdmin } = useUserRoles();

  // Check if user has admin access (Super Admin or Admin)
  const isAdmin = isSuperAdmin || (userRoles ?? []).some(role =>
    role.name === 'Admin'
  );

  switch (routeType) {
    case 'admin':
      return <AdminRouter />;
    case 'knowledge':
      return (
        <Suspense fallback={
          <div className="flex items-center justify-center min-h-[200px]">
            <LoadingSpinner message="Loading knowledge base..." fullScreen={false} />
          </div>
        }>
          <KnowledgeSection isAdmin={isAdmin} />
        </Suspense>
      );
    case 'default':
      return <DefaultRouter currentRole={currentRole} />;
    default:
      return (
        <div className="text-center text-muted-foreground py-8">
          Unknown route type: {routeType}
        </div>
      );
  }
});

ContentRouter.displayName = 'ContentRouter';